"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OfferPricingDetails_1 = require("../OfferPricingDetails");
const Pricing_1 = require("../Pricing");
const CreativeFormatAttribute_1 = require("./CreativeFormatAttribute");
const CreativeFormatCreativeType_1 = require("./CreativeFormatCreativeType");
const CreativeFormatNetwork_1 = require("./CreativeFormatNetwork");
const CreativeFormatPlacement_1 = require("./CreativeFormatPlacement");
class CreativeFormat {
    constructor({ id, resizeBaseId, network, placement, creativeType, attribute, offerPricingDetails, selectedPricingMerchandiseOptions, }) {
        this.toJSON = () => ({
            id: this.id,
            resizeBaseId: this.resizeBaseId,
            network: this.network.toJSON(),
            placement: this.placement.toJSON(),
            creativeType: this.creativeType.toJSON(),
            attribute: this.attribute.toJSON(),
            offerPricingDetails: this.offerPricingDetails,
            selectedPricingMerchandiseOptions: this.selectedPricingMerchandiseOptions,
        });
        // pricing用のkeyを返す
        this.getPricingKey = (itemType) => {
            if (itemType === 'express') {
                const camelizedActionType = this.actionType.slice(0, 1).toUpperCase() + this.actionType.slice(1);
                return `expressPerDayFor${camelizedActionType}`;
            }
            else {
                return this.actionType;
            }
        };
        this.id = id;
        this.resizeBaseId = resizeBaseId;
        this.network = network;
        this.placement = placement;
        this.creativeType = creativeType;
        this.attribute = attribute;
        this.offerPricingDetails = offerPricingDetails;
        this.selectedPricingMerchandiseOptions = selectedPricingMerchandiseOptions;
    }
    get actionType() {
        return this.resizeBaseId ? 'resize' : 'create';
    }
}
CreativeFormat.fromJSON = (json) => {
    const { id, resizeBaseId, network, placement, creativeType, attribute, offerPricingDetails, selectedPricingMerchandiseOptions, } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    const creativeFormatCreativeType = CreativeFormatCreativeType_1.default.fromJSON(creativeType);
    const creativeFormatAttribute = CreativeFormatAttribute_1.default.fromJSON(attribute);
    const _offerPricingDetails = offerPricingDetails ? OfferPricingDetails_1.default.fromJSON(offerPricingDetails) : undefined;
    const _selectedPricingMerchandiseOptions = selectedPricingMerchandiseOptions
        ? selectedPricingMerchandiseOptions.map((_selectedPricingMerchandiseOption) => Pricing_1.PricingMerchandiseOption.fromJSON(_selectedPricingMerchandiseOption))
        : undefined;
    return new CreativeFormat({
        id,
        resizeBaseId,
        network: CreativeFormatNetwork_1.default.fromJSON(network),
        placement: CreativeFormatPlacement_1.default.fromJSON(placement),
        creativeType: creativeFormatCreativeType,
        attribute: creativeFormatAttribute,
        offerPricingDetails: _offerPricingDetails,
        selectedPricingMerchandiseOptions: _selectedPricingMerchandiseOptions,
    });
};
exports.default = CreativeFormat;
